import stateService from "./stateService";
import routingService from "./routingService";
import { stateEvents } from "../models/states";

// A modal page of the dashboard - the signing tools page has no route of its
// own - opened from anywhere: an open dashboard takes it at once (and clears
// it, takePendingModal); otherwise the app goes to the dashboard, which opens
// it when it mounts.
let pending = null;

export const openDashboardModal = (type) => {
  pending = type;
  stateService.event(stateEvents.openModalPage, type);
  if (pending) routingService.push(routingService.routeNames.dashboard);
};

export const takePendingModal = () => {
  const type = pending;
  pending = null;
  return type;
};

// the workspace's signing tools page
export const openSigningTools = () => openDashboardModal(routingService.routeNames.signature);
